
// 获取图片url，用来页面显示
export async function getObjectByImgFile(file: File) {
    let imageBytes = null;
    let url = null;
    if (file && file.type.includes('image')) {
        imageBytes = new Uint8Array(await file.arrayBuffer());
        url = URL.createObjectURL(file);
    }
    console.log('getObjectByImgFile, url:', url);
    return url;
}

export async function getSrcByImgFile(file: File) {
    let result = '';
    if (file) {
        if (file.type.includes('image')) {
            result = URL.createObjectURL(file);
        }
        if (file.type.includes('video')) {
            result = new URL('/images/video-icon.png', import.meta.url).href;
        }
    }
    return result;
}

// 判断是否为经语义处理的ply模型文件 .ply且头信息包含 property float weight helen 2026-04-20 未完成，待开发
export async function isPlyHeatmapFile(file: File | string) {
    const filename = typeof file === 'string' ? file : file.name;
    const extension = filename.split('.').pop() || '';
    console.log('is PlyHeatmapFile, file:', filename,extension,extension==='ply');
    if (extension === 'ply') {
        try {
            const header = (await readFileHeader(file)).toLowerCase();
            if (!header.startsWith('ply')) {
                console.log('不是 PLY 文件:', filename);
                return false;
            }

            // const requiredKeywords = [
            //     'property float weight_0',
            //     'property float weight_1',
            //     'property float weight_2',
            //     ...
            // ];
            const requiredKeywords=[];
            for(let i=0;i<64;i++){
                requiredKeywords.push(`property float weight_${i}`);
            }

            const hasAllBaseProps = requiredKeywords.every(keyword => header.includes(keyword));
            console.log(`PLY 文件 ${filename} 3DGS 检测结果: 基础属性=${hasAllBaseProps}`);

            return hasAllBaseProps;
        } catch (error) {
            console.warn('读取 PLY 头信息失败，按非 3DGS 处理:', filename, error);
            return false;
        }
    }
    return false;
}

async function readFileHeader(file: File | string, maxBytes = 4096): Promise<string> {
    if (typeof file === 'string') {
        const response = await fetch(file, {
            headers: {
                Range: `bytes=0-${Math.max(maxBytes - 1, 0)}`
            }
        });
        if (!response.ok) {
            throw new Error(`读取线上文件失败: ${response.status} ${response.statusText}`);
        }
        const text = await response.text();
        return text.slice(0, maxBytes);
    }

    const slice = file.slice(0, maxBytes);
    const arrayBuffer = await slice.arrayBuffer();
    return new TextDecoder('utf-8').decode(arrayBuffer || new ArrayBuffer(0));
}

////////////////////  for marble4api////////////////////////////////////////////////////////////////////////
export function getFileKind(file_name: string) {
    const extension = file_name.split('.').pop() || '';
    if (extension === 'jpg' || extension === 'jpeg' || extension === 'png' || extension === 'webp') {
        return 'image';
    } else if (extension === 'mp4' || extension === 'mov' || extension === 'mkv') {
        return 'video';
    }
    return '';
}
export function getFileName(file_name: string) {
    return file_name.split('.').slice(0, -1).join('.');
}
